// @ts-nocheck





import { fetchRequest } from './index';
import { convertFromKmToM, convertFromMToKm } from '../pure/unitConversions';

export const convertDataFromServer = (tripRange) => ({
  ...tripRange,
  amount: convertFromMToKm(tripRange.amount)
});

const convertDataToServer = (tripRange) => ({
  ...tripRange,
  amount: convertFromKmToM(tripRange.amount)
});

export const addTripRange = async (
tripRange) =>
{
  const added = await fetchRequest.post(
    '/tripRange',
    convertDataToServer(tripRange)
  );
  if (added) return convertDataFromServer(added);
  throw new Error(
    'Не удалось создать участок маршрута с указанным топливным коэффициентом'
  );
};

export default {
  addTripRange
};